<template>
    <div class="bg p-3 pb-6">
        <div class="form-columns-fit mb-4">
            <div class="columns is-flex-wrap">
                <div class="column is-half is-full-mobile">
                    <vss-select
                        title="empresa"
                        :value="empresaSelected"
                        :options="empresaSelect"
                        :loading="empresaLoading"
                        @search="carregarEmpresa"
                        @input="updateEmpresa"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(1)"
                        title="cliente"
                        :value="clienteSelected"
                        :options="clienteSelect"
                        :loading="clienteLoading"
                        @search="carregarClientes"
                        @input="updateCliente"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(2)"
                        title="contrato"
                        :value="contratoSelected"
                        :options="contratoSelect"
                        :loading="contratoLoading"
                        @search="carregarContratos"
                        @input="updateContrato"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(3)"
                        title="tipo-servico"
                        :value="tiposervicoSelected"
                        :options="tiposervicoSelect"
                        :loading="tiposervicoLoading"
                        @search="carregarTiposervicos"
                        @input="updateTiposervico"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(4)"
                        title="lps"
                        :value="lpsSelected"
                        :options="lpsSelect"
                        :loading="lpsLoading"
                        @search="carregarLps"
                        @input="updateLps"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div class="column is-half is-full-mobile">
                    <vss-select
                        :id="generateId(5)"
                        title="colaborador"
                        :value="colaboradorSelected"
                        :options="colaboradorSelect"
                        :loading="colaboradorLoading"
                        @search="carregarColaborador"
                        @input="updateColaborador"
                        label="nome"
                        multiple
                        searchable
                        clearable
                        :closeOnSelect="false"
                    />
                </div>
                <div 
                    class="column is-2" 
                    v-for="(value, name) in boolFilters"
                    :key="name"
                >
                    <div class="is-flex is-flex-column">
                        <label class="mb-1" :class="{'mt-4': value.label === 'com-justificativa' || value.label === 'assinatura'}">
                            {{ $t(value.label) }}
                        </label>
                        <b-switch
                            :id="generateId(6)"
                            v-model="value.isChecked"
                            size="is-medium"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClienteService from '@/services/promotor/ClienteService.js';
import ProContratoService from '@/services/promotor/pro_cliente/ProContratoService.js';
import TipoServicoService from '@/services/promotor/TipoServicoService.js';
import ProLpsService from '@/services/promotor/ProLpsService.js';
import EmpresaService from '@/services/vendas/empresa/EmpresaService.js';
import GerenciarUsuariosService from '@/services/conta/GerenciarUsuariosService.js';

export default {
    props: {
        filtersReset: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            clienteService: new ClienteService(this.$http, this.$router),
            clienteLoading: false,
            clienteSelect: [],
            clienteSelected: [],

            contratoService: new ProContratoService(this.$http, this.$router),
            contratoLoading: false,
            contratoSelect: [],
            contratoSelected: [],

            tiposervicoService: new TipoServicoService(this.$http, this.$router),
            tiposervicoLoading: false,
            tiposervicoSelect: [],
            tiposervicoSelected: [],

            lpsService: new ProLpsService(this.$http, this.$router),
            lpsLoading: false,
            lpsSelect: [],
            lpsSelected: [],

            colaboradorService: new GerenciarUsuariosService(this.$http, this.$router),
            colaboradorLoading: false,
            colaboradorSelected: [],
            colaboradorSelect: [],

            empresaService: new EmpresaService(this.$http, this.$router),
            empresaLoading: false,
            empresaSelect: [],
            empresaSelected: [],

            boolFilters: {
                withRupturaTroca: {
                    label: 'ruptura-troca',
                    isChecked: false
                },
                withFormulario: {
                    label: 'formulario',
                    isChecked: false
                },
                withFoto: {
                    label: 'foto',
                    isChecked: false
                },
                withPesquisa: {
                    label: 'pesquisa',
                    isChecked: false
                },
                withVencimento: {
                    label: 'vencimento',
                    isChecked: false
                },
                withShare: {
                    label: 'share',
                    isChecked: false
                } ,
                withAssinatura: {
                    label: 'assinatura',
                    isChecked: false
                },
                withJustificativa: {
                    label: 'com-justificativa',
                    isChecked: false
                },
            },

            sort: {
                order: 'asc',
                column: 'descricao',
            },
        };
    },
    watch: {
        filtersReset(val) {
            if (val) this.clearFilter();
        },
        boolFilters: {
            handler: function (newBoolFilters) {
                const mappedFilters = {};

                for(const key in newBoolFilters) {
                    mappedFilters[key] = newBoolFilters[key].isChecked
                }

                this.$emit("update-bool-filters", mappedFilters);
            },
            deep: true
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarEmpresa(query) {
            query = this.isNull(query) ? '.*' : this.removeToSearch(query);
            this.empresaLoading = true;

            this.empresaService
                .findAllComboSituacao(4, query)
                .then((body) => {
                    if (body.content) {
                        this.empresaSelect = body.content.map((m) => {
                            return {
                                id: m.idempresa,
                                label:
                                    m.replicapda == 2
                                        ? 'Inativo | ' + m.nome + ' - ' + m.rsocial
                                        : m.nome + ' - ' + m.rsocial,
                                replicapda: m.replicapda,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.empresaSelect = [];
                    console.error('Erro ao carregar empresas.');
                })
                .finally((_) => {
                    this.empresaLoading = false;
                });
        },
        updateEmpresa(empresaSelected) {
            this.empresaSelected = empresaSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'idempresaList',
                valor:
                    this.empresaSelected.length == 0 ? [] : this.empresaSelected.map((e) => e.id),
            });
        },
        carregarClientes(query = '') {
            query = this.isNull(query) ? '' : this.removeToSearch(query);
            this.clienteLoading = true;

            this.clienteService
                .findAllComboSituacao(2, query)
                .then((body) => {
                    if (body.content) {
                        this.clienteSelect = body.content.map((m) => {
                            return {
                                id: m.idcliente,
                                label:
                                    m.situacao == 0
                                        ? 'Inativo | ' + m.nome + ' - ' + m.rsocial
                                        : m.nome + ' - ' + m.rsocial,
                                situacao: m.situacao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.clienteSelect = [];
                    console.error('Erro ao carregar clientes.');
                })
                .finally((_) => {
                    this.clienteLoading = false;
                });
        },
        updateCliente(clienteSelected) {
            this.clienteSelected = clienteSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'idclienteList',
                valor:
                    this.clienteSelected.length == 0 ? [] : this.clienteSelected.map((e) => e.id),
            });
        },
        carregarContratos(query = '', byCliente = false) {
            query = this.isNull(query) ? '' : this.removeToSearch(query);
            this.contratoLoading = true;
            if (byCliente) this.contratoSelect = [];

            this.contratoService
                .findAllComboSituacao(2, query)
                .then((body) => {
                    body.content.map((e) => {
                        this.contratoSelect.push({ id: e.idcontrato, label: e.descricao });
                    });
                }, 350)
                .catch((e) => {
                    this.contratoSelect = [];
                    console.error(`Erro ao realizar pesquisa de contratos:  ${e}`);
                })
                .finally((_) => {
                    this.contratoLoading = false;
                });
        },
        updateContrato(contratoSelected) {
            this.contratoSelected = contratoSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'idcontratoList',
                valor:
                    this.contratoSelected.length == 0 ? [] : this.contratoSelected.map((e) => e.id),
            });
        },
        carregarTiposervicos(query = '') {
            query = this.isNull(query) ? '' : this.removeToSearch(query);
            this.tiposervicoLoading = true;
            this.tiposervicoService
                .findAll(this.sort.column, this.sort.order, 0, 50, 1, query)
                .then((body) => {
                    this.tiposervicoSelect = [];
                    if (body.content.length > 0) {
                        body.content.map((e) => {
                            this.tiposervicoSelect.push({
                                id: e.idtiposervico,
                                label: e.descricao,
                            });
                        });
                    }
                }, 350)
                .catch((e) => {
                    this.tiposervicoSelect = [];
                    console.error(`Erro ao realizar pesquisa de contratos:  ${e}`);
                })
                .finally((_) => {
                    this.tiposervicoLoading = false;
                });
        },
        updateTiposervico(tiposervicoSelected) {
            this.tiposervicoSelected = tiposervicoSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'idtiposervicoList',
                valor:
                    this.tiposervicoSelected.length == 0
                        ? []
                        : this.tiposervicoSelected.map((e) => e.id),
            });
        },
        carregarLps(query = '') {
            query = this.isNull(query) ? '' : this.removeToSearch(query);
            this.lpsLoading = true;

            this.lpsService
                .findAll('nome', this.sort.order, 0, 50, 1, query)
                .then((body) => {
                    body.content.map((e) => {
                        this.lpsSelect.push({ id: e.idlps, label: e.nome });
                    });
                }, 350)
                .catch((e) => {
                    this.lpsSelect = [];
                    console.error(`Erro ao realizar pesquisa de lps:  ${e}`);
                })
                .finally((_) => {
                    this.lpsLoading = false;
                });
        },
        updateLps(lpsSelected) {
            this.lpsSelected = lpsSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'idlpsList',
                valor: this.lpsSelected.length == 0 ? [] : this.lpsSelected.map((e) => e.id),
            });
        },
        carregarColaborador(query = '') {
            query = this.isNull(query) ? '' : this.removeToSearch(query);
            this.colaboradorLoading = true;

            this.colaboradorService
                .findAllComboSituacao(2, query)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idusuario,
                            idusuario: m.idusuario,
                            nome: m.situacao != 'A' ? 'Inativo | ' + m.nome : m.nome,
                            situacao: m.situacao,
                        };
                    });
                })
                .then((content) => {
                    this.colaboradorSelect = content;
                })
                .catch((e) => {
                    this.colaboradorSelect = [];
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`);
                })
                .finally((_) => {
                    this.colaboradorLoading = false;
                });
        },

        updateColaborador(colaboradorSelected) {
            this.colaboradorSelected = colaboradorSelected;
            this.$emit('update-filtro', {
                nomeFiltro: 'idusuarioList',
                valor:
                    this.colaboradorSelected.length == 0
                        ? []
                        : this.colaboradorSelected.map((e) => e.id),
            });
        },

        /* Metodos que realizam a limpeza dos dados */
        clearFilter() {
            this.clienteSelected = [];
            this.contratoSelected = [];
            this.tiposervicoSelected = [];
            this.lpsSelected = [];
            this.colaboradorSelected = [];
            this.empresaSelected = [];
            this.boolFilters = {
                withRupturaTroca: {
                    label: 'ruptura-troca',
                    isChecked: false
                },
                withFormulario: {
                    label: 'formulario',
                    isChecked: false
                },
                withFoto: {
                    label: 'foto',
                    isChecked: false
                },
                withPesquisa: {
                    label: 'pesquisa',
                    isChecked: false
                },
                withVencimento: {
                    label: 'vencimento',
                    isChecked: false
                },
                withShare: {
                    label: 'share',
                    isChecked: false
                } ,
                withAssinatura: {
                    label: 'assinatura',
                    isChecked: false
                },
                withJustificativa: {
                    label: 'com-justificativa',
                    isChecked: false
                },
            }
        },
    },
};
</script>
